// @ts-nocheck
import styled from 'styled-components';

import { ReportingSectionAdvancedFilter } from '@/modules/reporting/ReportingSectionAdvancedFilter';

export const SectionHeaderStyled = styled.div`
  margin-bottom: 24px;
  width: 100%;

  .sectionHeader {
    &__header {
      align-items: center;
      display: flex;
    }

    &__content {
      margin-top: 8px;
    }

    &__buttonContainer {
      display: flex;
      gap: 8px;
    }

    &__buttonFilters,&__buttonComments {
      height: 40px;
      padding: 0 16px;
      white-space: nowrap;

      &-closeIcon {
        font-size: 18px !important;

        &--hide {
          display: none;
        }
      }
    }
  }
`;

export const ReportingSectionAdvancedFilterStyled = styled(ReportingSectionAdvancedFilter)`
  margin: 0;
`;
